import { DEFINITION_SLUGS } from '@/libs/definitions'

// id_task_priorities → slug (BE #72). Etiket `priorities.<slug>` anahtarından çevrilir.
// Eşlemenin kaynağı `DEFINITION_IDS.priority` (#143).
export const PRIORITY_SLUGS = DEFINITION_SLUGS.priority

export default PRIORITY_SLUGS
